import { render, staticRenderFns } from "./ListNewsletter.vue?vue&type=template&id=787a7bd0&scoped=true&"
import script from "./ListNewsletter.vue?vue&type=script&lang=js&"
export * from "./ListNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787a7bd0",
  null
  
)

export default component.exports